export default __webpack_public_path__ + "static/media/work-leg.ed8d31c4.png";